module.exports = __webpack_public_path__ + "img/story015@2x.a03a2d10.webp";